import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import constantes from '../resources/constantes.json';

const Logo = ({
  codpar,
  ambito,
  width,
  height,
  basenameUrl,
  children,
  shouldDisplayEmptySpace,
  shouldUseFallback,
  defaultBackgroundColor,
  isJpg = false,
  redondo = false,
  stylesContenedorLogo,
  hideLogo,
  //className,
  ...rest
}) => {
  const basename = basenameUrl
    ? basenameUrl
    : `${constantes.rutas.logo}${codpar.padStart(4, '0')}`;
  const [imageLoaded, setImageLoaded] = useState(false);

  const imageUrl = basename
    ? `${basename}.${isJpg ? 'jpg' : 'png'}`
    : undefined;
  const savedLogo = imageUrl;

  useEffect(() => {
    const image = new Image();
    image.src = savedLogo;

    image.onload = () => {
      setImageLoaded(true);
    };
  }, [savedLogo]);

  return (
    <>
      {imageLoaded || !shouldDisplayEmptySpace ? (
        <ContenedorLogos
          // className={className ?? ''}
          style={stylesContenedorLogo}
          width={width}
          height={height}
        >
          {hideLogo ? null : (
            <>
              {shouldUseFallback && <Fallback width={width} height={height} />}
              {savedLogo && (
                <LogoImg
                  {...rest}
                  src={savedLogo}
                  alt=""
                  redondo={redondo}
                  style={{
                    width: shouldDisplayEmptySpace ? width ?? '60px' : '',
                    margin: shouldDisplayEmptySpace ? 0 : '',
                  }}
                />
              )}
            </>
          )}
        </ContenedorLogos>
      ) : children ? (
        children
      ) : (
        <div
          style={{
            width: width ?? '60px',
            height: height ?? '60px',
            backgroundColor: defaultBackgroundColor ?? '#c2c2c2',
          }}
        />
      )}
    </>
  );
};
export default Logo;

const ContenedorLogos = styled.div`
  /* width: 60px;
  height: 60px; */
  width: ${({ width, height }) =>
    width !== undefined ? width : height ? 'auto' : '60px'};
  height: ${({ width, height }) =>
    height !== undefined ? height : width ? 'auto' : '60px'};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
`;

const LogoImg = styled.img`
  //position: absolute;
  max-height: 100%;
  height: 100%;
  border-radius: ${({ redondo }) => (redondo ? '50%' : '0')};
  background-color: transparent;
`;

const Fallback = styled.div`
  //position: absolute;
  background: transparent;
  /* width: 60px;
  height:60px; */
  width: ${({ width }) => (width !== undefined ? width : '60px')};
  height: ${({ height }) => (height !== undefined ? height : '60px')};
`;
